module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Bluetooth_16"],"path":[{"$":{"d":"M12.16,4.62,9,6.69V2.54ZM9,13.46V9.31l3.16,2.08Zm5.07-2.14L9,8l5.07-3.32a.07.07,0,0,0,0-.12L7.14,0A.22.22,0,0,0,7,0S7,0,7,.08V6.69L3,4.1l-.13,0L2.12,5a.07.07,0,0,0,0,.06.08.08,0,0,0,0,.05L6.51,8,2.14,10.86a.07.07,0,0,0,0,.11l.8.92.06,0H3L7,9.31v6.61A.08.08,0,0,0,7,16h0l.05,0,6.92-4.54a.07.07,0,0,0,0-.12Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Bluetooth_16.svg
// module id = f8bd
// module chunks = 1